var styles = {"kraken":"styles_kraken__T9vIt","extraSmall":"styles_extra-small__cetkB","small":"styles_small__c4Iit","medium":"styles_medium__gF4t6","large":"styles_large__Xd2PT","extraLarge":"styles_extra-large__SHx4x"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
